// extracted by mini-css-extract-plugin
module.exports = {"input":"diagnosis_input__XexlD","label":"diagnosis_label__CWu_T","text":"diagnosis_text__imD9v"};